import { render, staticRenderFns } from "./MultiSelectAutocomplete.vue?vue&type=template&id=38d6bf9a&scoped=true"
import script from "./MultiSelectAutocomplete.vue?vue&type=script&lang=js"
export * from "./MultiSelectAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./MultiSelectAutocomplete.vue?vue&type=style&index=0&id=38d6bf9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d6bf9a",
  null
  
)

export default component.exports